import {getMapControlsWidth} from './controls';
import {getSidebarWidth} from './sidebars';

export function getMapCenter(
    map: mapboxgl.Map | undefined,
    isDrawerOpen: boolean,
    sidebar: SidebarState
): number[] | undefined {
    if (!map) return;

    const centerPointLatLng = map.getCenter().wrap();

    // get the pixel X,Y position of the map center
    const centerPointXY = map.project(centerPointLatLng);

    // translate map center X coordinate to account for drawer; reducing the
    // width of the map by X will translate the center point by 1/2 of X
    centerPointXY.x += getMapControlsWidth(isDrawerOpen) / 2;

    // translate map center X coordinate to account for sidebar
    if (sidebar.type !== 'hidden') centerPointXY.x += getSidebarWidth() / 2;

    // convert translated center point back to map Lat/Lng
    const translatedCenterPointLatLng = map.unproject(centerPointXY);

    return translatedCenterPointLatLng.toArray();
}
